import React, { ReactElement } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { SurveyRenderer } from "./components";
import { ErrorBoundary, SnackbarContextProvider } from "./context";
import "./styles";

const App = (): ReactElement => {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarContextProvider>
          <SurveyRenderer />
        </SnackbarContextProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
